import { Crown, X, Sparkles, CheckCircle2, Zap } from "lucide-react";
import "./CompanyGoldTrialModal.scss";

export default function CompanyGoldTrialModal({ onClose }) {
    return (
        <div className="company-gold-overlay">
            <div className="company-gold-modal">
                <button
                    type="button"
                    className="company-gold-close"
                    onClick={onClose}
                    aria-label="Fechar"
                >
                    <X size={20} />
                </button>

                <div className="company-gold-header">
                    <div className="company-gold-crown-wrapper">
                        <Crown size={32} fill="currentColor" />
                    </div>
                    <span className="company-gold-badge">
                        <Sparkles size={13} />
                        PRESENTE ESPECIAL
                    </span>
                    <h2>30 Dias de Gold Liberados para sua Empresa!</h2>
                    <p>
                        Aproveite todos os recursos avançados da nossa plataforma sem nenhum custo durante os próximos 30 dias para contratar os melhores talentos.
                    </p>
                </div>

                <div className="company-gold-benefits">
                    <div className="benefit-item">
                        <div className="benefit-icon">
                            <CheckCircle2 size={18} />
                        </div>
                        <div>
                            <strong>Destaque nas vagas</strong>
                            <span>Suas oportunidades aparecem primeiro para os melhores freelancers.</span>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon">
                            <CheckCircle2 size={18} />
                        </div>
                        <div>
                            <strong>Selo de Empresa Verificada</strong>
                            <span>Mais credibilidade e atratividade na hora de atrair candidaturas.</span>
                        </div>
                    </div>

                    <div className="benefit-item">
                        <div className="benefit-icon">
                            <CheckCircle2 size={18} />
                        </div>
                        <div>
                            <strong>Visão</strong>
                            <span>Sua empresa passa mais credibilidade no feed de vagas.</span>
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className="company-gold-button"
                    onClick={onClose}
                >
                    <Zap size={18} />
                    Começar a usar o Gold agora
                </button>
            </div>
        </div>
    );
}